import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import AccountServiceModel      from '@/models/AccountServiceModel';
import TimestampAble            from '@widesk-core/models/traits/TimestampAble';
import Blamable                 from '@/models/traits/Blamable';
import FunctionalityModel       from '@/models/services/account/FunctionalityModel';
import AccountSubscriptionModel from '@/models/services/account/AccountSubscriptionModel';

@model.urnResource('account_subscription_functionality')
@doc.path('/account_subscription_functionalities/{?id}')
export default class AccountSubscriptionFunctionalityModel extends Blamable(TimestampAble(AccountServiceModel)) {
	private declare _tsFilters: {
		'id': id;
		'accountSubscription.account': id;
		'accountSubscription': id;
		'accountSubscription.accountSubscriptionStatus': '1' | '0';
		'functionality.reference': Account_FunctionalityReference;
	};

	private declare _tsSorts: {
		'id': string;
	};	

	@doc.model(AccountSubscriptionModel) declare accountSubscription: AccountSubscriptionModel;
	@doc.model(FunctionalityModel) declare functionality: FunctionalityModel;
	@doc.string declare value: string;
}